<template>
  <b-form
    v-if="show"
    @submit="onSubmit">
    <b-form-group
      id="input-group-order"
      label="Ordre"
      label-for="input-order">
      <b-form-input
        id="input-order"
        v-model="form.order"
        type="number"
        maxlength ="2"
      />
    </b-form-group>
    <b-form-group
      id="input-group-module-name"
      label="Nom d'affichage du module"
      label-for="input-module-name">
      <b-form-input
        id="input-module-name"
        v-model="form.theme_name"
        type="text"
      />
    </b-form-group>

    <b-form-group
      v-if="module.pmo_data && module.pmo_data.uri && module.pmo_data.type && module.pmo_data.type === 'web'"
      id="input-group-params"
      label="Paramètres"
      label-for="input-params">
      <b-form-input
        id="input-module-params"
        v-model="form.params_uri"
        type="text"
      />
    </b-form-group>
    <b-button
      type="submit"
      variant="primary">Enregistrer</b-button>
  </b-form>
</template>

<script>

export default {
  name: 'FormModuleSetting',
  props: {
    module: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      form: {
        modu_id: null,
        theme_name: null,
        icon_name: null,
        params_uri: null,
        order: null,
      },
      params: [],
      show: true,
    };
  },
  mounted() {
    this.form.modu_id = this.module.modu_id;
    this.form.theme_name = this.module.tmo_data ? this.module.tmo_data.name : null;
    this.form.icon_name = this.module.tmo_data ? this.module.tmo_data.iconName : null;
    this.form.order = this.module.show_order;
    this.form.params_uri = this.module.pmo_data
                          && this.module.pmo_data.uri
                          && this.module.pmo_data.type
                          && this.module.pmo_data.type === 'web' ? this.module.pmo_data.uri : null;
    this.$store.dispatch('modules/getParamsModule',
      { modu_id: this.module.modu_id })
      .then(response => this.loadParams(JSON.parse(JSON.stringify(response.data))));
    this.params = []; // TODO : Récupérer la liste des paramètres disponibles pour ce module
  },
  methods: {
    onSubmit(evt) {
      evt.preventDefault();
      this.$emit('sendForm', JSON.stringify(this.form), this.module);
    },
    getParamsType(params) {
      if (params) {
        if (params.uri && params.type && params.type === 'web') {
          return 'Site web: ';
        }
        if (params.uri) {
          return 'Application: ';
        }
        if (params.action) {
          return 'Action: ';
        }
      }
      return 'Module ANISEN: ';
    },
    getParamsInfos(params) {
      if (params) {
        if (params.uri) {
          return params.uri;
        }
        if (params.action) {
          return params.action;
        }
        if (params.is_abstract) {
          return 'Abstrait';
        }
      }
      return '';
    },
    loadParams(value) {
      
    }
  },
};
</script>

<style scoped>

</style>
